import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/contact/components/Content/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/contact/components/Form/index.tsx")